import React from 'react';

interface Props {
    src?: string;
    setSrc: (newSrc: string) => void;
}

function BlockEdit({src, setSrc}: Props) {
 return (
  <div>
      <p>Search for a widget in the search field below:</p>
      <input type="text" value={src} onChange={e => {
          setSrc(e.target.value);
      }}/>
  </div>
 );
};

export default BlockEdit;